import { useState } from "react";
import { signal } from "@preact/signals-react";

import DatePicker from "componentsv2/form/DatePicker";
import BasicTable from "componentsv2/table/BasicTable";
import { layout as layoutPrices } from "./ModelWizardRates";
import { useWizard } from "storev2/wizardStore";
import { useTable } from "storev2/tableStore";
import proxy from "api/proxy";

function WizardUpdate({ args }) {
  const data = args.data;
  const [msg, setMsg] = useState(null);
  const { store, record } = useWizard();
  const { setTable } = useTable();

  const parentRec = {
    record: record,
    fieldName: "rates",
  };

  const attrsStartDatePicker = {
    label: "hotel.calendar.update_start_date",
    name: "start_date",
    labeled: false,
    onChange: onChangeDate,
    data: args.start_date,
  };

  const attrsEndDatePicker = {
    label: "hotel.calendar.update_end_date",
    name: "end_date",
    labeled: false,
    onChange: onChangeDate,
    data: args.end_date,
  };

  async function onChangeDate(name, value) {
    if (name === "start_date") {
      store.start_date = value;
    } else if (name === "end_date") {
      store.end_date = value;
    }
    if (store.start_date && store.end_date) {
      if (store.end_date >= store.start_date) {
        data.value = await getDataSheetPrices();
        setMsg(null);
      } else {
        setMsg("Fechas inválidas!");
      }
    }
  }

  async function getDataSheetPrices() {
    const { operation_center, rate_plan } = args;
    const argsVar = {
      model: "hotel.calendar",
      method: "get_sheet_prices",
      args: [
        {
          operation_center: operation_center.value.id,
          rate_plan: rate_plan.value.id,
        },
      ],
    };
    const { data } = await proxy.methodCall(argsVar);
    const res = new Map();
    let idx = 1;
    for (const val of data) {
      for (const pl of val.price_lists) {
        res.set(idx, {
          id: idx,
          accommodation: { id: val.id, name: val.label },
          price_list: { id: pl.id, name: pl.label },
          unit_price: signal(0),
        });
        idx += 1;
      }
    }
    store.rates = res;
    const key = "hotel.calendar.line";
    const records = Array.from(store.rates.values());
    const layout = layoutPrices();
    setTable({ layout, storeId: key, records, domain: false });
    return res;
  }

  const attrs = {
    parentRec: parentRec,
    layout: layoutPrices(),
    storeId: "hotel.calendar.line",
  };

  return (
    <div className="pr-8">
      <div className="flex gap-x-4 mb-4">
        <DatePicker {...attrsStartDatePicker} />
        <DatePicker {...attrsEndDatePicker} />
      </div>
      {msg && (
        <div>
          <span>{msg}</span>
        </div>
      )}
      {data.value && <BasicTable {...attrs} records={data.value} />}
    </div>
  );
}

export default WizardUpdate;
